module.exports = __webpack_public_path__ + "img/loading.6aab350a.svg";